module.exports = __webpack_public_path__ + "static/media/32.c7b21057.jpg";